// src/pages/VentingRoomContent/DashboardContent.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaBalanceScale,
    FaChartLine,
    FaHeartBroken,
    FaLeaf,
    FaExclamationTriangle,
    FaSpinner
} from 'react-icons/fa';
import '../../styles/VentingRoomDashboard.css';
import PostModal from './PostModal';
import { UserContext } from '../../UserContext';

const iconColor = '#78909C';

const topicSections = [
    { id: 'social-injustice', label: 'Social Injustice', icon: <FaBalanceScale color={iconColor} size={60} /> },
    { id: 'economic-hell', label: 'Economic Hell', icon: <FaChartLine color={iconColor} size={60} /> },
    { id: 'romantic-chaos', label: 'Romantic Chaos', icon: <FaHeartBroken color={iconColor} size={60} /> },
    { id: 'ecosystem-plus', label: 'Ecosystem +', icon: <FaLeaf color={iconColor} size={60} /> },
    { id: 'emergency', label: 'Emergency', icon: <FaExclamationTriangle color={iconColor} size={60} /> },
];

function DashboardContent() {
    const navigate = useNavigate();
    const { userEmail } = useContext(UserContext); // Get user info from context
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTopicId, setSelectedTopicId] = useState(null);

    // This state is for loading and error handling within this component
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // This is a placeholder for your main dashboard component's useEffect,
    // which would fetch the dashboard stats data from the backend.
    useEffect(() => {
        const fetchStats = async () => {
            setIsLoading(true);
            try {
                // This call would be from the parent component, not here.
                // We'll just mock it for now.
                // In a real implementation, you might fetch and set dashboard data here.
            } catch (err) {
                setError("Failed to load dashboard data.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchStats();
    }, []);

    const handleTopicClick = (topicId) => {
        if (!userEmail) {
            navigate("/login"); // Redirect to login if not authenticated
            return;
        }
        setSelectedTopicId(topicId);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedTopicId(null);
    };

    const handlePostSuccess = () => {
        console.log("Post successful!");
        handleCloseModal();
    };
    
    return (
        <div className="dashboard-content-actual-wrapper">
            {isLoading ? (
                <div className="flex items-center justify-center min-h-[50vh]">
                    <FaSpinner className="animate-spin text-4xl text-blue-500" />
                </div>
            ) : error ? (
                <div className="flex items-center justify-center min-h-[50vh]">
                    <p className="text-red-500 text-lg">{error}</p>
                </div>
            ) : (
                <>
                    <h2 className="dashboard-content-title">Explore Topics</h2>
                    <div className="topic-card-grid">
                        {topicSections.map(topic => (
                            <div
                                key={topic.id}
                                className="topic-card"
                                onClick={() => handleTopicClick(topic.id)}
                                role="button"
                                tabIndex={0}
                            >
                                <div className="topic-icon">{topic.icon}</div>
                                <h3 className="topic-label">{topic.label}</h3>
                            </div>
                        ))}
                    </div>
                </>
            )}
            
            <PostModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                topicId={selectedTopicId}
                userEmail={userEmail}
                onPostSuccess={handlePostSuccess}
            />
        </div>
    );
}

export default DashboardContent;
